import { __awaiter } from '../_virtual/_tslib.js';
import API from './const.js';
import { toast } from '../components/toast/toast.js';
import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import { useVahakQuery, useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import { QueryNames } from './hooks/queryNames.js';
import { getAuthHeader } from './utils/getAuthHeader.js';
import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'react';
import '../constants/serviceTypeId.js';
import '../constants/StateList.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import 'bowser';
import './auth.service.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import { generateQueryString } from '../methods/generateQueryString.js';
import 'crypto-js';

function searchByPhone(customerMobile) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${API.CUSTOMER_PROFILE_DETIALS_BY_PHONE}p_n=${customerMobile}`, {
                method: "GET",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", key: process.env.NEXT_PUBLC_REACT_APP_KEY || "" }, getAuthHeader())
            }));
            if (call.status === 200) {
                const response = yield call.json();
                return response.data;
            }
            if (!call.ok) {
                throw yield call.json();
            }
        }
        catch (error) {
            /**
             * Uncomment the toast, after the backend stopsthrowing error for normal user roles.
             */
            // toast.error("An error occured, please try again after sometime", DefaultToastOptions);
        }
    });
}
function getUserRoles(userId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${API.GET_USER_ROLES}id=${userId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            }));
            if (call.status === 200) {
                const response = yield call.json();
                return response.data;
            }
            if (!call.ok) {
                throw yield call.json();
            }
        }
        catch (error) {
            toast.error("An error occured, please try again after sometime");
        }
    });
}
const AuthServiceAdminConsole = {
    searchByPhone,
    getUserRoles
};
function useSearchCompanyByPhoneNumber({ phoneNumber }, options) {
    const { GET } = useVahakHttpClient();
    const searchCompanyByPhoneNumber = () => {
        const queryObj = { p_n: phoneNumber };
        return GET(API.CUSTOMER_PROFILE_DETIALS_BY_PHONE, queryObj);
    };
    return useVahakQuery([QueryNames.searchCompanyByPhoneNumber, phoneNumber], searchCompanyByPhoneNumber, options);
}
const useSearchCompanyByPhoneNumberMutation = () => {
    const { GET } = useVahakHttpClient();
    function method(params) {
        const { phoneNumber } = params;
        const payload = {
            p_n: phoneNumber
        };
        const urlString = generateQueryString(payload);
        return GET(`${API.CUSTOMER_PROFILE_DETIALS_BY_PHONE}${urlString}`);
    }
    return useVahakMutationQuery([QueryNames.searchCompanyByPhoneNumber], method);
};

export { AuthServiceAdminConsole, useSearchCompanyByPhoneNumber, useSearchCompanyByPhoneNumberMutation };
//# sourceMappingURL=auth.adminConsole.service.js.map
